"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
/**
 * `useMountEffect`
 *
 * Handles component onMount() in the render function.
 * @param {Disposable} onMountCallback - this function will be called only once when the component is mounted.
 */
function useMountEffect(onMountCallback) {
    react_1.useEffect(function () { return onMountCallback(); }, []);
}
exports.useMountEffect = useMountEffect;
exports.default = useMountEffect;
//# sourceMappingURL=use-mount-effect.js.map